<template>
    <v-data-table
        :headers="headers"
        :items="questions"
    >
    </v-data-table>
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
    data() {
        return {
            headers: [
                {
                    text: '#',
                    value: 'number'
                }, {
                    text: 'Pertanyaan',
                    value: 'question_summary'
                }, {
                    text: 'Jawaban',
                    value: 'correct_answer'
                }
            ]
        }
    },

    computed: sync('createtryout/*'),
}
</script>
